import axios from 'axios'
import qs from 'qs'
import { showLoading, hideLoading } from './loading'
axios.defaults.timeout = 5000
let baseApiUrl = 'https://www.flikef.com/api/'
// let baseApiUrl = 'http://127.0.0.1:3040/api/'
axios.defaults.baseURL = baseApiUrl

// 设置默认请求头
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'Content-type': 'application/x-www-form-urlencoded'
}
// 序列化参数
axios.defaults.transformRequest = (data) => {
  data = qs.stringify(data)
  return data
}
let cancel = {}
let promiseArr = {}
const CancelToken = axios.CancelToken


export default {
  // get请求
  get (url, param, loading) {
    return new Promise((resolve, reserr) => {
      if (loading) {
        showLoading()
      }
      if (!param) {
        param = {}
      }
      axios({
        method: 'get',
        url,
        params: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        if (loading) {
          hideLoading()
        }
        if (res.status === 200) {
          resolve(res)
        } else {
          resolve(res)
        }
      }).catch(error => {
        if (loading) {
          hideLoading()
        }
        reserr(error)
      })
    })
  },
  // post请求
  post (url, param, loading) {
    return new Promise((resolve, reserr) => {
      if (loading) {
        showLoading()
      }
      if (!param) {
        param = {}
      }
      axios({
        method: 'post',
        url,
        data: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        if (loading) {
          hideLoading()
        }
        if (res.status == 200) {
          resolve(res)
        } else {
          resolve(res)
        }
      }).catch(error => {
        if (loading) {
          hideLoading()
        }
        reserr(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/http.js